import ContextMenu from "ol-contextmenu";
import { format } from "ol/coordinate";
import { inAndOut } from "ol/easing";
import Feature from "ol/Feature.js";
import { Point } from "ol/geom.js";
import { transform } from "ol/proj";
import { Fill, Icon, Stroke, Style, Text } from "ol/style.js";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MapPin from "../icons/mappin.png";
import { setResultsData } from "../redux/resultsSlice";
import { setStreetView } from "../redux/toolSelectSlice";
import { findAddress } from "./Geocoding/geocodingUtil";
import MapContext from "./MapContext";
import { bufferGeometry, doesIntersect, getMapLayerById } from "./utils/mapUtils";

const RightClickMenu = () => {
    const mapConfig = useSelector((state) => state.configData.mapConfig);
    const { map } = useContext(MapContext);
    const vectorLayers = useSelector((state) => state.configData.vectorLayerProperties);
    const streetViewEnabled = useSelector(
        (state) => state.configData.thirdPartyMaps?.GoogleStreetView?.Enabled
    );
    //console.log(streetViewEnabled);
    const dispatch = useDispatch();

    useEffect(() => {
        if (map) {
            LoadRightClickMenu();
        }
    }, [map]);

    let items = [
        {
            text: "Loading...",
        },
        "-", // this is a separator
        {
            text: "What's Here",
            classname: "some-style-class", // add some CSS rules
            callback: identity, // `center` is your callback function
        },
        ...(streetViewEnabled
            ? [
                  {
                      text: "Open Street View",
                      classname: "some-style-class", // add some CSS rules
                      callback: streetView, // `center` is your callback function
                  },
              ]
            : []),
        {
            text: "Center map here",
            classname: "some-style-class", // add some CSS rules
            callback: center, // `center` is your callback function
        },
        {
            text: "Coordinate",
            classname: "some-style-class", // you can add this icon with a CSS class
            // instead of `icon` property (see next line)
            //icon: 'img/marker.png', // this can be relative or absolute
            callback: coordinate,
        },
        // '-', // this is a separator
    ];

    //console.log(items);

    const contextmenu = new ContextMenu({
        width: 170,
        defaultItems: true, // defaultItems are (for now) Zoom In/Zoom Out
        items: items,
    });

    contextmenu.on("beforeopen", function (evt) {
        let coordinate = map.getCoordinateFromPixel(evt.pixel);
        contextmenu.clear();
        items[0] = { text: "Loading..." };
        contextmenu.extend(items);
        findAddress(mapConfig, coordinate, (rtv) => {
            contextmenu.clear();
            items[0] = {
                text: rtv.replace(",", "<br/>"),
            };
            contextmenu.extend(items);
        });
    });

    const LoadRightClickMenu = () => {
        map.addControl(contextmenu);
    };

    function coordinate(obj) {
        const coordinateLayer = getMapLayerById(map, "coordinateLayer");
        const coord4326 = transform(
            obj.coordinate,
            mapConfig.map.projection,
            "EPSG:4326"
        );
        let template = "Lat: {y} \nLong: {x}";
        let iconStyle = new Style({
            image: new Icon({ displacement: [0, 12], scale: 0.4, src: MapPin }),
            text: new Text({
                offsetY: 25,
                text: format(coord4326, template, 5),
                font: "15px Open Sans,sans-serif",
                fill: new Fill({ color: "#111" }),
                stroke: new Stroke({ color: "#eee", width: 2 }),
            }),
        });

        let feature = new Feature({
            type: "removable",
            geometry: new Point(obj.coordinate),
        });

        feature.setStyle(iconStyle);
        coordinateLayer.getSource().addFeature(feature);
    }
    function center(obj) {
        map.getView().animate({
            duration: 750,
            easing: inAndOut,
            center: obj.coordinate,
        });
    }

    function streetView(obj) {
        map.getView().animate({
            duration: 750,
            easing: inAndOut,
            center: obj.coordinate,
        });
        setTimeout(() => {
            dispatch(setStreetView(true));
        }, 1000);
    }

    function identity(obj) {
        let geometry = new Point(obj.coordinate);
        geometry = bufferGeometry(geometry, null, map.getView().targetResolution_);
        setIntersectingFeatures(geometry);
    }

    // This function is more else the same from Identity Options
    // Take a geometry and tests if all 'ShowMapTips' layers on the map intersect
    // sets intersecting features to state
    const setIntersectingFeatures = (geometry) => {
        const extent = geometry.getExtent();
        const allLayers = map.getAllLayers();
        const layers = [];
        allLayers.forEach((layer) => {
            const isVisible = layer.getVisible();
            const layerId = layer.values_.Id;
            // match layer from map to saved config data in state
            const matchedLayer = vectorLayers.find((mapLayer) => mapLayer.Id === layerId);
            // check to see if it was in state and is ShowMapTips
            if (matchedLayer && matchedLayer.Identifiable === true && isVisible) {
                // create array for storing the id of each feature in extent
                const featureIds = [];
                const featuresInExtent = layer.getSource().getFeaturesInExtent(extent);
                featuresInExtent.forEach((feature) => {
                    const intersection = doesIntersect(feature, geometry); // returns boolean
                    // if there is an intersection push the feature id to the array
                    if (intersection === true) {
                        featureIds.push(feature.id_);
                    }
                });
                // if there were intersections between features in layer and test geometry
                // create object with data from matched layer in state
                // with an array of the features that intersected
                if (featureIds.length > 0) {
                    const layerObj = {
                        DisplayName: matchedLayer.DisplayName,
                        FeatureLabel: matchedLayer.FeatureLabel,
                        FeatureDescription: matchedLayer.FeatureDescription,
                        Id: matchedLayer.Id,
                        Features: featureIds,
                    };
                    layers.push(layerObj);
                }
            }
        });
        dispatch(setResultsData(layers));
    };

    return <></>;
};

export default RightClickMenu;
